import { BodyPostStreetviewHouseholdData, StreetviewHouseholdDataResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import {
  AdapterInterface, HouseholdGroup, MapHeadlines, StreetviewHouseholdData,
} from '../../types/global';
import adaptFilterRequest from './adaptFilterRequest';
import BaseAdapter from './baseAdapter';

export default class PostStreetviewHouseholds extends BaseAdapter<StreetviewHouseholdDataResponse> implements AdapterInterface {
  rawResponse: StreetviewHouseholdDataResponse;

  modifiedRequest: BodyPostStreetviewHouseholdData;

  async adaptResponse(request: { data: SelectedFilters, signal: AbortSignal }): Promise<StreetviewHouseholdData> {
    const formattedRequest = this.adaptRequest(request.data);

    await this.fetchApiResponse('/api/streetview-household-data', HTTPMethod.Post, formattedRequest, request.signal);
    return this.displayResponse();
  }

  displayResponse(): StreetviewHouseholdData {
    const mapHeadlines: MapHeadlines[] = this.rawResponse.map_headlines.map((headline) => ({
      displayName: headline.display_name,
      description: headline.description,
      value: headline.value,
    }));

    const householdGroups: HouseholdGroup[] = this.rawResponse.household_groups.map((group) => ({
      households: group.households.map((household) => ({
        householdReference: household.household_reference,
        clientName: household.client_name,
      })),
      coordinates: group.coordinates,
    }));

    return { mapHeadlines, householdGroups };
  }

  adaptRequest(selectedFilters: SelectedFilters): BodyPostStreetviewHouseholdData {
    this.modifiedRequest = adaptFilterRequest(selectedFilters);
    return this.modifiedRequest;
  }
}
